"use client";

import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "../inputs/button";

interface ExpandCollapseToggleProps {
  isExpanded: boolean;
  onToggle: () => void;
  /** Label shown when collapsed. Defaults to "Expand". */
  collapsedLabel?: string;
}

export function ExpandCollapseToggle({
  isExpanded,
  onToggle,
  collapsedLabel = "Expand",
}: ExpandCollapseToggleProps) {
  return (
    <>
      {!isExpanded && (
        <div className="h-8 -mt-8 relative z-10 bg-gradient-to-t from-background to-transparent pointer-events-none" />
      )}
      <div className="border-b border-border" />
      <Button
        variant="ghost"
        size="row"
        type="button"
        onClick={onToggle}
        className="pt-3 pb-1 justify-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        {isExpanded ? (
          <>
            <ChevronUp className="h-4 w-4" />
            Collapse
            <ChevronUp className="h-4 w-4" />
          </>
        ) : (
          <>
            <ChevronDown className="h-4 w-4" />
            {collapsedLabel}
            <ChevronDown className="h-4 w-4" />
          </>
        )}
      </Button>
    </>
  );
}
